import { createCRUDHook } from './createCRUDHook';
import { PartManufacturerDto } from 'utils/models';
import { CRM_MANUFACTURER_PART } from './apiEndPoints';

const { Context, useManager, useConsumer } =
  createCRUDHook<PartManufacturerDto>({
    entityName: 'ManufacturerPart',
    endpoint: CRM_MANUFACTURER_PART,
  });

export const ManufacturerPartContext = Context;
export const useManufacturerPartManager = useManager;
export const useManufacturerPart = useConsumer;
